import { get, post } from './http-calls';

export const getWorkAccomplishCodes = async () => {
    let res = await get('/WorkAccomplishedCodes', { useAuthToken: true });
    return res;
};
export const getUsersDropdown = async () => {
    let res = await get('MessagesMaster/Get_UserRoles', { useAuthToken: true });
    return res;
};

export const PostmasterMessage = async (state) => {
    let res = await post(
        `MessagesMaster`,
        {
            messageID: state.messageID || null,
            messageDescription: state.messageDescription || '',
            messageIsActive: state.messageIsActive || false,
            roleIds: typeof state.roleIds === 'string' ? JSON.parse(state.roleIds.replace(/([a-f0-9-]+)/gi, '"$1"')) : state.roleIds || [],
            messageTitle: state.messageTitle || ''
        },
        { useAuthToken: true }
    );
    return res;
};
